import React from 'react';
import Items from 'components/app/erp/Items';

// Route-level page entry for ERP Items (see components/app/erp/Items for the shell).
const ItemPage = () => <Items />;

export default ItemPage;
